import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, Length } from 'class-validator';
import { CreateEmpresaDto } from 'src/empresas/dto/create-empresa.dto';

export class RegistroDto extends CreateEmpresaDto {
  @ApiProperty({ example: '6264957', description: 'Usuario (username)' })
  @IsNotEmpty({ message: 'Usuario es obligatorio' })
  @Length(3, 50, { message: 'Usuario debe tener entre 3 y 50 caracteres' })
  usuario: string;

  @ApiProperty({ example: '123456', description: 'Password' })
  @IsNotEmpty({ message: 'Password es obligatorio' })
  @Length(6, 100, { message: 'Password debe tener al menos 6 caracteres' })
  password: string;
}
